module.exports = __webpack_public_path__ + "img/02_pic1.da790960.png";